var ProfilePage = {};

ProfilePage.billingFields = [
  {name: "billingFirstName", required: true},
  {name: "billingLastName", required: true},
  {name: "billingEmail", required: true},
  {
    name: "billingPhone", required: true, regexp: function (input, form) {
      var phone = input.value.replace(/-|\s+/g, "");
      if (input.value && !/^(\+[0-9]{2})*[0-9]{9}$/g.test(phone)) {
        return false;
      }
      return true;
    }
  },
  {name: "billingStreet", required: true},
  {name: "billingHouseNumber", required: true},
  {
    name: "billingZip", required: true, regexp: function (input, form) {
      var postcode = input.value.replace(/\s+/g, "");
      if (postcode && !/^[0-9]{2}-[0-9]{3}$/g.test(postcode)) {
        return false;
      }
      return true;
    }
  },
  {name: "billingCity", required: true}
];

ProfilePage.deliveryFields = [
  {name: "deliveryFirstName", required: true},
  {name: "deliveryLastName", required: true},
  {
    name: "deliveryPhone", required: true, regexp: function (input, form) {
      var phone = input.value.replace(/-|\s+/g, "");
      if (input.value && !/^(\+[0-9]{2})*[0-9]{9}$/g.test(phone)) {
        return false;
      }
      return true;
    }
  },
  {name: "deliveryStreet", required: true},
  {name: "deliveryHouseNumber", required: true},
  {
    name: "deliveryZip", required: true, regexp: function (input, form) {
      var postcode = input.value.replace(/\s+/g, "");
      if (postcode && !/^[0-9]{2}-[0-9]{3}$/g.test(postcode)) {
        return false;
      }
      return true;
    }
  },
  {name: "deliveryCity", required: true}
];

ProfilePage.passwordFields = [
  {name: "password", required: true},
  {
    name: "repassword",
    required: true,
    regexp: function (input, form) {
      return form.elements.password.value === input.value;
    }
  }
];

ProfilePage.emailFields = [
  {
    name: "new_email",
    required: true,
    regexp: function (input, form) {
      if (input.value && !/^\w+([\+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(input.value)) {
        return false;
      }
      return true;
    }
  }
];

ProfilePage.init = function () {
  if(!$('#profile_nav').length) return;
  $('#profile_nav').select2().on('select2:select', function (e) {
    window.location.href = e.params.data.id;
  });
  $('#changePassBtn').click(ProfilePage.changePasswordClick);
  $('#changeEmailBtn').click(ProfilePage.changeEmailClick);
  $("#submitBilling").click(ProfilePage.onBillingAddressSubmit);
  $("#submitDelivery").click(ProfilePage.onDeliveryAddressSubmit);
};

ProfilePage.onBillingAddressSubmit = function (evt) {
  evt.preventDefault();
  var errors = Forms.validateFields(document.forms.billingAddressForm, ProfilePage.billingFields);
  if (errors.length === 0) {
    document.forms.billingAddressForm.submit()
  }
};

ProfilePage.onDeliveryAddressSubmit = function (evt) {
  evt.preventDefault();
  var errors = Forms.validateFields(document.forms.deliveryAddressForm, ProfilePage.deliveryFields);
  if (errors.length === 0) {
    document.forms.deliveryAddressForm.submit();
  }
};

ProfilePage.changePasswordClick = function () {
  var form = document.forms.pswForm;
  Forms.clearFormErrors(form);
  var errors = Forms.validateFields(form, ProfilePage.passwordFields);
  if (errors.length) {
    return;
  }
  jQuery.ajax({
    url: '/account/settings/update-password',
    method: "post",
    data: JSON.stringify({newPassword: form.elements.password.value}),
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      if (resp.status === 400) {
        $('[data-for="password"][data-kind="custom"]').show();
        return;
      }
      $('#paswdModal').popup('show');
    }
  });
};

ProfilePage.changeEmailClick = function () {
  var form = document.forms.emailForm;
  Forms.clearFormErrors(form);
  var errors = Forms.validateFields(form, ProfilePage.emailFields);
  if (errors.length) {
    return;
  }
  jQuery.ajax({
    url: '/account/settings/set-email',
    method: "post",
    data: JSON.stringify({email: form.elements.new_email.value}),
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      if (resp.error && resp.error.status === 409) {
        $('[data-for="new_email"][data-kind="custom"]').show();
        return;
      }
      $('#emailModal span.email').html(form.elements.new_email.value);
      $('#emailModal').popup('show');
    }
  });
};

$(ProfilePage.init);
